<div class="alert alert-{{ type }}">
	<span class="fw-semibold"> <ng-content></ng-content></span>
	<i class="ph-{{ icon }} float-end ms-2"></i>
</div>
